import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';

import {PencilIcon} from '@heroicons/react/20/solid';

export default class Payments extends React.Component {

    BreadcrumbPages = [ 
        { name: 'Multas', href: '#', current: false },
        { name: 'Administracion de pagos', href: '#', current: true },
    ]

    constructor(props) {
        super(props);
        this.state = {
        payments: []
        };
    }

    renderTable = () => {
        return(
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                    <h1 className="text-base font-semibold text-gray-900">Lista de Multas</h1>
                    <p className="mt-2 text-sm text-gray-700">
                        En esta seccion podras registrar pagos a multas realizadas.
                    </p>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                    <button
                        type="button"
                        className="block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                    >
                        REGISTRAR PAGO
                    </button>
                    </div>
                </div>
                <div className="mt-8 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                    Fecha
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Identificacion
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Placa
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Estado
                                </th>
                                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                    <span className="sr-only">Edit</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                <tr key={1}>
                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                        2024/12/12
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">25 530 217</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">KEE 39D </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">PENDIENTE</td>
                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                        <button className="text-indigo-600 hover:text-indigo-900">
                                            <button 
                                                type="button"
                                                className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                            >
                                                <PencilIcon aria-hidden="true" className="h-5 w-5" />
                                            </button>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
        )
    }


    render() {
        return (
        <div>
            <Breadcrumb pages={this.BreadcrumbPages}/>
            <div style={{paddingTop:10}}>
                {this.renderTable()}
            </div>
        </div>
        );
    }
}